/* 14/10 (chu shop): khach chon "Style of Strap" -> anh gallery nhay toi anh cua kieu do.
   Bam the Classic -> anh CLASSIC; bam Fixed Bars -> anh FIXED BARS ...
   - Ghep theo TEN FILE cua media (data-tep tren o nho gallery, do section in ra khi bat "style_photo"),
     khong cung id: gan them media moi vao bai thi chay luon, khong can sua code.
   - Chi chay khi section bat style_photo (bespoke). Khong tim thay media khop -> anh giu nguyen.
   - Chuyen anh bang CHINH nut o nho (cstrap-engine.js co san cuonToiLogic): chi cuon track NGANG,
     khong dong vao scrollY cua trang -> khong nhay trang tren dien thoai.
   - Chi theo thao tac that cua khach (isTrusted): luc tai trang / engine tu dat lai khong doi anh. */
(function () {
  'use strict';
  var root = document.querySelector('.cstrap-section');
  if (!root) return;
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.cstrap__thumb[data-tep]'));
  if (thumbs.length < 2) return;

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  /* 16/10: Shopify them duoi _<uuid> khi gan anh trung ten (Hybrid_Rally_cff15de4-....jpg) -> bo duoi do */
  function stemOf(f) { return norm(String(f || '').replace(/\.[a-z0-9]+$/i, '').replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '')); }

  /* Ten kieu (da chuan hoa) -> cac "ten file" co the dung, theo thu tu uu tien. Kieu khong co trong bang
     thi thu chinh ten no. File 2D moi (Rally_Small_Holes, Rally_Large_Holes, Wings_cut, Middles_cut)
     duoc uu tien hon ban ve ky thuat cu cung kieu. */
  var ALIAS = {
    classic: ['classic'],
    microrally: ['rallysmallholes', 'microrally', 'rallyholes'],
    hybridrally: ['hybridrally'],
    rallylargeholes: ['rallylargeholes', 'rallylarge'],
    middlecut: ['middlescut', 'middlecut'],
    wingcut: ['wingscut', 'wingcut'],
    singlefolding: ['singlefolding', 'doublefolding'],   /* 16/10: bai design-your-own ten file la Double_Folding */
    fixedbars: ['fixedbars'],
    /* 23/10: 4 kieu PAM -> 4 so do trong bai (ten file custom-panerai-style-watch-strap-<dong>.webp) */
    submersible: ['custompaneraistylewatchstrapsubmersible', 'submersible'],
    radiomir: ['custompaneraistylewatchstrapradiomir', 'radiomir'],
    luminor: ['custompaneraistylewatchstrapluminor', 'luminor'],
    luminordue: ['custompaneraistylewatchstrapluminordue', 'luminordue'],
    pammicrorally: ['custompaneraistylewatchstrapmicrorally'],
    pamhybridrally: ['custompaneraistylewatchstraphybridrally'],
    pamrallylargeholes: ['custompaneraistylewatchstraprallylargeholes'],
    /* 23/10: 3 kieu Apple Watch -> so do trong bai (custom-apple-watch-strap-<kieu>.webp) */
    applewatchclassic: ['customapplewatchstrapclassic'],
    applewatchdoubletour: ['customapplewatchstrapdoubletour'],
    applewatchslim: ['customapplewatchstrapslim']
  };

  var stems = thumbs.map(function (t) { return stemOf(t.getAttribute('data-tep')); });

  function indexFor(styleName) {
    var k = norm(styleName);
    var keys = ALIAS[k] || [k];
    for (var pass = 0; pass < 2; pass++) {
      for (var a = 0; a < keys.length; a++) {
        for (var i = 0; i < stems.length; i++) {
          var st = pass ? stems[i].replace(/\d+$/, '') : stems[i];
          if (st === keys[a]) return i;
        }
      }
    }
    return -1;
  }

  function showStyle(styleName) {
    var i = indexFor(styleName);
    /* 16/10: kieu chua co anh rieng -> ve anh dau (anh tong), khong de dung anh kieu truoc gay hieu nham */
    if (i < 0) i = 0;
    /* nut o nho goi cuonToiLogic(i) cua engine; ham nay chi cuon track ngang. */
    thumbs[i].click();
  }

  function isStyleInput(el) {
    return el && el.matches && el.matches('input[type="radio"]') && el.name === 'properties[Style of Strap]';
  }

  root.addEventListener('change', function (e) {
    if (!e.isTrusted || !isStyleInput(e.target)) return;
    showStyle(e.target.value);
  });
  /* Bam lai the dang chon (vd Classic mac dinh) khong phat sinh "change" — van phai nhay toi anh. */
  root.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    var lab = e.target.closest && e.target.closest('label.cswatch');
    if (!lab || e.target.closest('.sw-zoom')) return;
    var inp = lab.querySelector('input[type="radio"]');
    if (isStyleInput(inp)) showStyle(inp.value);
  });
})();
